module.exports = __webpack_public_path__ + "img/avatar6.5575a7fb.png";